import { T19 } from "./ShareByCustomerGroupSales/T19";
import { T19_04 } from "./PesoSalesAndNumberOfCustomers/T19_04";

export const AgentCustomerSales = {
  "sections": [
    T19_04,
    T19
  ]
}